<!-- Uploaded to: SVG Repo, www.svgrepo.com, Transformed by: SVG Repo Mixer Tools -->
<svg
	fill="currentColor"
	height="30px"
	width="30px"
	version="1.1"
	id="Layer_1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	viewBox="0 0 392.598 392.598"
	xml:space="preserve"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<g>
			<g>
				<path
					d="M196.267,0.032c-23.143,0-42.02,18.877-42.02,42.02s18.812,42.02,42.02,42.02s42.02-18.877,42.02-42.02 S219.41,0.032,196.267,0.032z M196.267,62.287c-11.119,0-20.234-9.05-20.234-20.234s9.115-20.234,20.234-20.234 s20.234,9.051,20.234,20.234S207.386,62.287,196.267,62.287z"
				/>
			</g>
		</g>
		<g>
			<g>
				<path
					d="M131.491,270.836c-5.883-9.891-9.115-21.657-9.115-33.293c0-22.238-17.907-40.404-40.016-40.404 c-22.109,0-40.016,18.166-40.016,40.404c0,12.154-3.491,24.372-9.762,34.392c-2.069,3.297-2.263,7.564-0.323,11.055 c1.875,3.491,5.495,5.624,9.568,5.624h81.067h0.065c6.012,0,10.925-4.848,10.925-10.925 C133.883,275.038,132.978,272.776,131.491,270.836z M59.022,266.828c3.362-9.309,5.042-19.394,5.042-29.285 c0-10.279,8.21-18.618,18.23-18.618s18.23,8.339,18.23,18.618c0,9.956,1.745,19.911,5.107,29.285H59.022z"
				/>
			</g>
		</g>
		<g>
			<g>
				<path
					d="M82.295,301.22C37.43,301.22,1.228,336.452,0,381.382c0.388,9.115,7.952,11.184,10.925,11.184h142.804 c2.909,0,10.214-1.552,10.925-11.184C163.426,336.452,127.289,301.22,82.295,301.22z M23.079,370.78 c5.883-27.539,29.996-47.774,59.216-47.774c29.22,0,53.333,20.234,59.216,47.774H23.079z"
				/>
			</g>
		</g>
		<g>
			<g>
				<path
					d="M359.305,270.836c-5.883-9.891-9.115-21.657-9.115-33.293c0-22.238-17.907-40.404-40.016-40.404 c-22.044,0-39.952,18.166-39.952,40.404c0,12.154-3.491,24.372-9.762,34.392c-2.069,3.297-2.263,7.564-0.323,11.055 c1.939,3.491,5.56,5.624,9.503,5.624h81.067h0.065c6.012,0,10.925-4.848,10.925-10.925 C361.697,275.038,360.792,272.711,359.305,270.836z M286.966,266.828c3.297-9.309,5.042-19.394,5.042-29.285 c0-10.279,8.21-18.618,18.23-18.618s18.23,8.339,18.23,18.618c0,9.956,1.745,19.911,5.107,29.285H286.966z"
				/>
			</g>
		</g>
		<g>
			<g>
				<path
					d="M310.238,301.22c-44.865,0-81.067,35.232-82.295,80.162c0.388,9.309,7.952,11.184,10.925,11.184h142.804 c2.909,0,10.408-1.745,10.925-11.184C391.305,336.452,355.168,301.22,310.238,301.22z M251.022,370.78 c5.883-27.539,29.996-47.774,59.216-47.774c29.22,0,53.333,20.234,59.216,47.774H251.022z"
				/>
			</g>
		</g>
		<g>
			<g>
				<path
					d="M284.509,176.129c-5.042-44.994-42.99-78.869-88.242-78.869c-45.253,0-83.2,33.939-88.242,78.869 c-0.323,3.103,0.646,6.206,2.715,8.469c2.069,2.263,5.042,3.62,8.145,3.62h66.457v24.63l-32.97,32.97 c-4.267,4.267-4.267,11.119,0,15.45c3.814,3.814,11.96,3.426,15.451,0l28.509-28.509l28.509,28.509 c4.202,4.267,11.055,4.267,15.321,0c4.267-4.267,4.267-11.119,0-15.45l-32.97-32.97v-24.63h66.457c3.103,0,6.012-1.293,8.145-3.62 C283.927,182.271,284.897,179.168,284.509,176.129z M132.202,166.368c8.404-27.733,34.069-47.386,64.065-47.386 s55.661,19.653,64.065,47.386H132.202z"
				/>
			</g>
		</g>
	</g>
</svg>
